<div class="teia-modal">
    <div class="td-cnt-ext">
        <div class="td-cnt-md">
            <div class="td-cnt-title">
                <span class="te-title">{{ 'itdcr.visualOverview' | translate}} <span class="te-subtitle">{{
                        itdcrNo}}</span></span>

            </div>
            <div class="td-cnt-body">
                <div class="flow">
                    <div class="flow-step" *ngFor="let s of steps; let last = last; let first = first">
                        <div class="flow-connector" [class.hidden]="last"></div>
                        <div class="flow-bullet" [ngClass]="statusClass(s.status)"></div>

                        <div class="flow-card">
                            <div class="flow-header">
                                <div class="flow-title">{{ s.title || '—' }}</div>
                                <!-- <span class="flow-status" [ngClass]="statusClass(s.status)">{{ s.status || '—' }}</span> -->
                                <span class="notes-button fal fa-note-sticky" *ngIf="s.notes" role="button" tabindex="0"
                                    (click)="openNotes(s.notes, s.title)" (keydown.enter)="openNotes(s.notes, s.title)"
                                    (keydown.space)="openNotes(s.notes, s.title)"></span>

                            </div>

                            <div class="flow-dates">
                                <div class="flow-date" *ngIf="s.creationDate">{{'itdcr.created' | translate}}: {{
                                    s.creationDate |
                                    date:(first ? globals.dateFormat : globals.dateTimeFormat) }}</div>
                                <div class="flow-date" *ngIf="s.submissionDate">{{'itdcr.submitted' | translate}}: {{
                                    s.submissionDate |
                                    date:(first ? globals.dateFormat : globals.dateTimeFormat) }}</div>
                                <div class="flow-date" *ngIf="s.finishingDate">{{'itdcr.finished' | translate}}: {{
                                    s.finishingDate |
                                    date:(first ? globals.dateFormat : globals.dateTimeFormat) }}</div>
                                <div class="flow-date" *ngIf="s.endDate">{{'itdcr.ended' | translate}}: {{ s.endDate |
                                    date:(first ? globals.dateFormat : globals.dateTimeFormat) }}
                                </div>
                                <div class="flow-date" *ngIf="s.duration !== null && s.duration !== undefined">
                                    {{'itdcr.duration' | translate}}: {{s.duration
                                    }} {{'itdcr.workingDays' | translate}}</div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div class="td-cnt-btn">
                <teiasoft-button (click)="onCloseClick()" [type]="'tb-cancel'" [text]="'commons.close' | translate"
                    class="mr-5"></teiasoft-button>
            </div>
        </div>

    </div>
</div>

<ng-template #notesTpl let-data>
    <h2 mat-dialog-title>{{ data.title || ('itdcr.notes' | translate) }}</h2>
    <mat-dialog-content>
        <div class="notes-content">{{ data.notes }}</div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-button mat-dialog-close>
            {{ 'commons.close' | translate }}
        </button>
    </mat-dialog-actions>
</ng-template>